import i18n from "i18next";

i18n.init({
	resources: {
		en: {
			translations: {
				slogan: "Handle your properties with a snap.",
				dashboard: "Dashboard",
				properties: "Properties",
				tenants: "Tenants",
				newTenant: "New Tenant",
				expanses: "Expenses",
				rents: "Rents",
				rent: "Rent Amount",
				rentCollected: "Rent collected",
				incomeSoFar: "This is income earned so far.",
				addNewProperty: "New Property",
				editProperty: "Edit Property",
				editRent: "Edit Rent",
				saveData: "Save Data",
				cashflow: "Cashflow",
				occupancy: "Occupancy",
				totalDueExpanses: "Total expenses",
				totalDueExpansesSoFar:
					"These are the total due expenses so far.",
				propertyDetails: "Property Details",
				selectProperty: "Select Property",
				units: "Units",
				rooms: "Rooms",
				propertyExpanse: "Expenses",
				propertyRent: "Rents",
				addPropertyRent: "Add Rent",
				addExpanse: "Add Expense",
				editExpanse: "Edit Expense",
				addRent: "Add Rent",
				sureToDelProperty:
					"Are you sure you want to delete this property? This action can not be undone!",
				sureToDel: "Are you sure you want to delete this record?",
				fillForm:
					"Please fill all the required fields before submitting the form.",
				propertyDataAdded: "Property has been added.",
				propertyDataUpdated: "Property has been updated.",
				addExpError1:
					"Please write description and enter amount of the expense.",
				addExpError2:
					"Please enter tenant name and amount of the rent.",
				addAmountError: "Please enter a valid amount.",
				addExpMsg: "Expense has been added.",
				addRentMsg: "Rent has been added.",
				clickToSeeDetails: "Click to see details",
				editRentData: "Edit Rent Data",
				addPropertyExpanse: "Add Property Expense",
				editExpanseData: "Edit Expense Data",
				cancel: "Cancel",
				yes: "Yes",
				ok: "Ok",
				name: "Name",
				enterName: "Enter Name",
				email: "Email",
				phone: "Phone",
				address: "Address",
				unitOptional: "Unit (Optional)",
				tenantOptional: "Tenant (Optional)",
				tenant: "Tenant",
				selectStatus: "Select Status",
				status: "Status",
				vacant: "Vacant",
				occupied: "Occupied",
				occupiedBy: "Occupied by",
				city: "City (Optional)",
				state: "State (Optional)",
				province: "Province (Optional)",
				zipCode: "Zip Code (Optional)",
				postalCode: "Postal Code (Optional)",
				addDescription: "Add Description",
				addExpanse: "Add Expense",
				tenantName: "Tenant Name",
				addUnitOptional: "Add Unit (Optional)",
				noDataFound: "No Data Found",
				edit: "Edit",
				delete: "Delete",
				addTenant: "Add Tenant",
				addNewTenant: "Add New Tenant",
				editTenant: "Edit Tenant",
				deleteTenant: "Delete Tenant",
				addProperty: "Add Property",
				deleteProperty: "Delete Property",
				saveChanges: "Save Changes",
				lattitude: "Lattitude (Optional)",
				longitude: "Longitude (Optional)",
				currencySymbol: "TJS",
				overdueRent: "Overdue Rent",
				overdueRentCurrentMonth: "Overdue rent of all times",
				from: "From",
				to: "To",
				toSmall: "to",
				year: "Year",
				income: "Income",
				expense: "Expense",
				paid: "Paid",
				notPaid: "Not Paid",
				clickToSeeDetails: "Click to see details",
				mapLocation: "Map Location",
				logout: "Logout",
				login: "Login",
				password: "Password",
				jan: "Jan",
				feb: "Feb",
				mar: "Mar",
				apr: "Apr",
				may: "May",
				jun: "Jun",
				jul: "Jul",
				aug: "Aug",
				sep: "Sep",
				oct: "Oct",
				nov: "Nov",
				dec: "Dec",
				amount: "Amount",
				selectTenant: "Please select a tenant.",
				notRentedCantAddRent:
					"Property is not occupied. You cannot add a rent.",
				notRentedCantAddExpense:
					"Property is not occupied. You cannot add an expense.",
				date: "Date",
				requiredEmail: "Email is required.",
				requiredName: "Name is required.",
				requiredPassword: "Password is required.",
				requiredPhone: "Phone number is required.",
				validEmail: "Please enter a valid email address.",
				validPhone: "Please enter a valid phone number.",
				tenantSaved: "Tenant saved successfully.",
				tenantUpdated: "Tenant updated successfully",
				requiredAddress: "Address is required.",
				startRenting: "Start Renting",
				stopRenting: "Stop Renting",
				sure: "Are you sure?",
				rentingDate: "Renting Date",
				chooseTenant: "Choose a tenant",
				existing: "Existing",
				new: "New",
				requiredRentingDate: "Date is required.",
				nextRentingDate: "Next Renting Date",
				rentingStarted: "Renting Started",
				paymentHistory: "Payment history",
				forgotPassword: "Forgot password?",
				backToLogin: "Back to login page",
				sendEmail: "Send Email",
				users: "Users",
				newUser: "New User",
				newUserSuccess: "New user created successfully.",
				profile: "Profile",
				changePassword: "Change Password",
				currentPassword: "Current Password",
				newPassword: "New Password",
				repeatPassword: "Repeat Password",
				changesSaved: "Changes saved successfully.",
				passwordMustBeSame:
					"New password and Repeat password must be same.",
				passwordChanged:
					"Password changed successfully. Use new password to login next time.",
				emailSent:
					"Email sent successfully. Please check your inbox to reset your password.",
				resetPassword: "Reset Password",
				invalidPasswordResetToken:
					"Invalid password reset token provided.",
				createUser: "Create User",
				monthsTotal: "Months, Total",
				futurePayments: "Future payments",
				extra: "Extra",
				remaining: "Remaining"
			}
		},
		tj: {
			translations: {
				slogan: "Ба ҳама амволи худ дар як лаҳза дастрасӣ пайдо кунед.",
				dashboard: "Идоракуни",
				properties: "Амволхо",
				tenants: "Иҷорагир",
				newTenant: "Иҷорагири нав",
				expanses: "Хароҷот",
				rents: "Иҷора",
				rent: "Иҷора",
				rentCollected: "Иҷора ҷамъоварӣ шудааст",
				incomeSoFar: "Ин даромадест, ки то имрӯз гирифта шудааст.",
				addNewProperty: "Иловаи амвол",
				cashflow: "Ҷараёни нақдина",
				occupancy: "Ҷойгиршавӣ",
				totalDueExpanses: "Ҳаҷми умумии хароҷот",
				totalDueExpansesSoFar:
					"Инҳо ҳаҷми умумии xароҷот то ҳол мебошанд.",
				propertyDetails: "Тафсилоти амвол",
				units: "Воҳидҳо",
				rooms: "Ҳуҷраҳо",
				propertyExpanse: "Хароҷоти амвол",
				propertyRent: "Иҷораи амвол",
				addPropertyRent: "Иловаи иҷораи амвол",
				addExpanse: "Иловаи xароҷот",
				addRent: "Илова кардани иҷора",
				sureToDelProperty:
					"Шумо мутмаин ҳастед, ки мехоҳед ин амволро нест кунед? Ин амалро бекор кардан мумкин нест!",
				sureToDel:
					"Шумо мутмаин ҳастед, ки мехоҳед ин сабтро нест кунед?",
				fillForm:
					"Лутфан ҳамаи майдонҳои заруриро пеш аз пешниҳоди шакл пур кунед.",
				propertyDataAdded: "Амвол илова карда шуд.",
				propertyDataUpdated: "Амвол нав карда шуд.",
				addExpError1:
					"Лутфан тавсифро нависед ва маблағи харочотро ворид кунед.",
				addExpError2:
					"Лутфан номи иҷорагир ва маблағи иҷораро ворид кунед.",
				addAmountError: "Лутфан маблағи дурустро ворид кунед.",
				addExpMsg: "Хароҷот илова карда шуд.",
				addRentMsg: "Иҷора илова карда шуд.",
				cancel: "He",
				yes: "Бале",
				ok: "Хуб",
				name: "Ном",
				enterName: "Номро ворид кунед",
				email: "Почтаи электронӣ",
				phone: "Телефон",
				address: "Суроға",
				unitOptional: "Воҳиди (ихтиёрӣ)",
				tenantOptional: "Иҷорагир (ихтиёрӣ)",
				tenant: "Иҷорагир",
				selectStatus: "Ҳолат-ро интихоб кунед",
				vacant: "Холӣ",
				occupied: "Ишғол карда шудааст",
				occupiedBy: "Ишғол кардааст",
				city: "Шаҳр (ихтиёрӣ)",
				state: "Давлат (ихтиёрӣ)",
				province: "Вилоят (ихтиёрӣ)",
				zipCode: "Индекси почта (ихтиёрӣ)",
				postalCode: "Рамзи почта (ихтиёрӣ)",
				addDescription: "Иловаи Тавсиф",
				tenantName: "Номи иҷорагир",
				addUnitOptional: "Иловаи воҳид (ихтиёрӣ)",
				noDataFound: "Ягон маълумот ёфт нашуд",
				edit: "Таҳрир",
				delete: "Нобуд кунед",
				addTenant: "Иловаи иҷорагир",
				addNewTenant: "Иҷорагири нав илова кунед",
				editTenant: "Таҳрири иҷорагир",
				deleteTenant: "Иҷорагарро нест кунед",
				addProperty: "Иловаи амвол",
				editProperty: "Таҳрири амвол",
				deleteProperty: "Нобуд кардани амвол",
				saveData: "Захираи маълумот",
				editProperty: "Таҳрири амвол",
				editRent: "Таҳрири иҷора",
				selectProperty: "Амволро интихоб кунед",
				addExpanse: "Иловаи xароҷот",
				editExpanse: "Таҳрири xароҷот",
				clickToSeeDetails: "Барои дидани тафсилот клик кунед.",
				editRentData: "Таҳрири маълумоти иҷора",
				addPropertyExpanse: "Илова кардани амвол",
				editExpanseData: "Таҳрири маълумоти xароҷот",
				status: "Mақом",
				saveChanges: "Тағйиротро захира кунед",
				lattitude: "Паҳноӣ",
				longitude: "Тулу",
				currencySymbol: "CM",
				overdueRent: "Моҳ пардохт нашудааст",
				overdueRentCurrentMonth: "Иҷораи таъхир дар ҳама вақт",
				from: "Аз",
				to: "To",
				toSmall: "To",
				year: "Соли",
				income: "Даромад",
				expense: "Хароҷот",
				paid: "Пардохтшуда",
				notPaid: "Пардохт нашудааст",
				clickToSeeDetails: "Барои дидани тафсилот клик кунед",
				mapLocation: "Харитаи ҷойгиршавӣ",
				logout: "Баромадан",
				login: "Даромадан",
				password: "Рамз",
				jan: "январ",
				feb: "феврал",
				mar: "март",
				apr: "апрел",
				may: "май",
				jun: "июн",
				jul: "июл",
				aug: "август",
				sep: "сентябр",
				oct: "октябр",
				nov: "ноябр",
				dec: "декабр",
				amount: "Маблағ",
				selectTenant: "Иҷорагирро интихоб кунед",
				notRentedCantAddRent:
					"Амвол ишғол карда нашудааст. Шумо наметавонед иҷораро илова кунед.",
				notRentedCantAddExpense:
					"Амвол ишғол карда нашудааст. Шумо наметавонед хароҷот илова кунед.",
				date: "Сана",
				requiredName: "Ном лозим аст.",
				requiredPhone: "Рақами телефон лозим аст.",
				validEmail: "Лутфан имейли дуруст ворид намоед.",
				validPhone: "Лутфан рақами телефони дурустро ворид намоед.",
				tenantSaved: "Иҷорагир бомуваффақият ба қайд гуруфта шуд.",
				tenantUpdated: "Иҷорагир бомуваффақият нав карда шуд.",
				requiredAddress: "Адрес лозим аст.",
				startRenting: "Оғоз",
				stopRenting: "Анҷом",
				sure: "Шумо мутмаъин ҳастед?",
				rentingDate: "Санаи иҷора додан",
				chooseTenant: "Иҷорагирро интихоб кунед",
				existing: "Мавҷудбуда",
				new: "Нав",
				requiredRentingDate: "Сана лозим аст.",
				nextRentingDate: "Санаи иҷораи оянда",
				rentingStarted: "Иҷора сар шуд",
				paymentHistory: "Таърихи пардохт",
				forgotPassword: "Рамз фаромӯш шуд?",
				backToLogin: "Бозгашт ба саҳифаи воридшавӣ",
				sendEmail: "Ирсоли почтаи электронӣ",
				users: "Корбарон",
				newUser: "Корбари нав",
				newUserSuccess: "Корбари нав бомуваффақият сохта шуд.",
				profile: "Профил",
				changePassword: "Ивази Рамз",
				currentPassword: "Рамзи ҳозира",
				newPassword: "Рамзи нав",
				repeatPassword: "Такрори рамз",
				changesSaved: "Тағйирот бомуваффақият захира карда шуданд.",
				passwordMustBeSame:
					"Рамзи нав ва рамзи таркори бояд якхела бошанд.",
				passwordChanged:
					"Рамз бомуваффақият иваз карда шуд.  Барои ворид шудан рамзи навро истифода баред.",
				emailSent:
					"Почтаи электронӣ бомуваффақият фиристода шуд. Лутфан почтаи худро тафтиш кунед, то рамзи худро аз нав танзим кунед.",
				resetPassword: "Рамзро аз нав танзим дихед",
				invalidPasswordResetToken:
					"Аломати барқароркунии парол беэътибор дода шудааст.",
				createUser: "Корбари нав сохтан",
				monthsTotal: "Моҳҳо, Ҳамагӣ",
				futurePayments: "Пардохтҳои оянда",
				extra: "Илова",
				remaining: "Боқимонда"
			}
		}
	},
	fallbackLng: "tj",
	debug: false,
	ns: ["translations"],
	defaultNS: "translations",
	keySeparator: false,
	interpolation: {
		escapeValue: false,
		formatSeparator: ","
	}
});

export default i18n;
